<template>

  <transition name="fade">
    <div class="fxd .f -z-t b b-c c20" v-if="open">
      <div class="b-c b-cl a-c">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 160.64 160.64" :class="H < 300?'w-6':'w-9'"><defs><svg:style>.cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}</svg:style><linearGradient id="linear-gradient" x1="85.71" y1="1.73" x2="106.97" y2="158.92" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#33c599"></stop><stop offset="0.46" stop-color="#1dde99"></stop><stop offset="1" stop-color="#0f9"></stop></linearGradient><linearGradient id="linear-gradient-2" x1="140.24" y1="92.37" x2="148.48" y2="153.29" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#33b699"></stop><stop offset="1" stop-color="#0f9"></stop></linearGradient><linearGradient id="linear-gradient-3" x1="12.43" y1="92.05" x2="16.05" y2="118.8" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#3c9"></stop><stop offset="0.14" stop-color="#26d999"></stop><stop offset="0.44" stop-color="#1e9"></stop><stop offset="0.73" stop-color="#04fb99"></stop><stop offset="1" stop-color="#0f9"></stop></linearGradient></defs><polygon points="89.36 119.3 12.06 119.19 2.52 93.39 79.82 93.5 89.36 119.3" style="fill: currentColor;"></polygon><polygon points="27.51 154.78 82.57 5.86 55.06 5.86 0 154.78 27.51 154.78" style="fill: currentColor;"></polygon><polygon class="cls-1" points="110.08 154.68 55.06 5.87 82.57 5.86 137.62 154.78 110.08 154.68"></polygon><polygon class="cls-2" points="137.5 154.78 160.2 93.39 132.69 93.39 123.81 117.41 137.5 154.78"></polygon><polygon class="cls-3" points="13.15 119.19 12.06 119.19 2.52 93.39 22.7 93.39 13.15 119.19"></polygon></svg>
        <div class="m-y-7 Case" dir="ltr">
          <div v-if="refresh !== null">
            <div class="btn btn-n unt CASE" @click="refresh()">
              <i class="material-icons">refresh</i>
              refresh
            </div>
            <div class="font-en c# o-5">{{ $t("Something went wrong, try Refresh") }}</div>
          </div>
          <!-- LOADING...  -->
          <div v-if="refresh === null" class="prg w-f m-t-4 -r-c">
            <div class="prg-inf"></div>
          </div>
          <SwingTitle v-else :over="false">
          </SwingTitle>
          <!--span v-else>
            {{ labelText }}
            <br><SwingTitle :over="true">{{ labelIcons }}</SwingTitle></span-->
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import SwingTitle from '../components/SwingTitle'

export default {
  components: {
    SwingTitle
  },
  computed: {
    ...mapState(['H'])
  },
  name: 'loading',
  props: {
    open: Boolean,
    label: String,
    refresh: Function
  },
  data () {
    return {
      labelText: this.label,
      labelIcons: ''
    }
  },
  mounted () {
    // 🦠🐛😷
    var dot = '.'
    var setIntervalDots = setInterval(() => {
      if (!this.open) {
        clearInterval(setIntervalDots)
      }
      if (this.labelIcons.split('.').length > 3) {
        dot = '😷'
        this.labelIcons = ''
      } else if (this.labelIcons.split('😷').length > 3) {
        dot = '💊'
        this.labelIcons = ''
      } else if (this.labelIcons.split('💊').length > 3) {
        dot = '💡'
        this.labelIcons = ''
      } else if (this.labelIcons.split('💡').length > 3) {
        dot = '.'
        this.labelIcons = ''
      }
      this.labelIcons += dot
    }, 300)
  }
}
</script>
